import React, { useState } from "react";
import styles from "../Customer_Talks/Customer_Talks.module.css";
import Star from "../../images/5star.jpeg";
import customers_Dummy_Talks from "../../Data/Dummy_Data";

const Customer_Talks = () => {
  const [limit, setLimit] = useState(5);

  return (
    <div className={styles.container}>
      <h2 id={styles.talks_heading}>Customers Talks</h2>
      {customers_Dummy_Talks.slice(0, limit).map((data, index) => {
        return (
          <>
            <div className={styles.name_Card}>
              <h2>{data.name}</h2> |<h5>{data.date}</h5> |
              <img src={Star} alt="" />
            </div>
            <div className={styles.description_Card}>
              <p>{data.description}</p>
            </div>
          </>
        );
      })}
      <button onClick={() => setLimit(limit + 3)} id={styles.more_Talks}>
        more...
      </button>
    </div>
  );
};

export default Customer_Talks;
